export default {
  default: () => import("/builds/webcontact/borsdorf/layouts/default.vue"),
  foerderverein: () => import("/builds/webcontact/borsdorf/layouts/foerderverein.vue"),
  grundschule: () => import("/builds/webcontact/borsdorf/layouts/grundschule.vue"),
  kindergarten: () => import("/builds/webcontact/borsdorf/layouts/kindergarten.vue"),
  parthenstrolche: () => import("/builds/webcontact/borsdorf/layouts/parthenstrolche.vue")
}